module.exports = __webpack_public_path__ + "static/media/Feedbackbg.895ebba9.png";